import { Box, Stack, Tab, Tabs } from '@mui/material'
import React from 'react'
import { a11yProps, TabPanel } from '../../../../components/Tabs'
import ProductTicketSales from './Tickets/ProductTicketSales'
import EventSeatIcon from '@mui/icons-material/EventSeatRounded'
import LocalActivityIcon from '@mui/icons-material/LocalActivityRounded'
import HistoryIcon from '@mui/icons-material/HistoryRounded'
import ProductTicketLogs from './Tickets/ProductTicketLogs'
import ProductTicketAreasLots from './Tickets/ProductTicketAreasLots'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumberRounded'
import ProductTicketSettings from './Tickets/ProductTicketSettings'
import { ProductTicketProps } from '../../ProductTypes'

const ProductTickets = (props: ProductTicketProps): JSX.Element => {
  const { watch } = props
  const [value, setValue] = React.useState(0)

  const productId = watch('id')
  const offers = watch('prices')

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Stack
      width="100%"
      direction="row"
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 2,
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        scrollButtons="auto"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider', width: 264 }}
      >
        <Tab
          label="Configurações"
          icon={<ConfirmationNumberIcon />}
          iconPosition="start"
          {...a11yProps(0)}
          sx={{
            alignSelf: 'start',
            orientation: 'isMobile',
            textTransform: 'none',
          }}
        />
        <Tab
          label="Áreas & Lotes"
          icon={<EventSeatIcon />}
          iconPosition="start"
          {...a11yProps(1)}
          sx={{
            alignSelf: 'start',
            orientation: 'isMobile',
            textTransform: 'none',
          }}
        />
        <Tab
          label="Ingressos vendidos"
          icon={<LocalActivityIcon />}
          iconPosition="start"
          {...a11yProps(2)}
          sx={{
            alignSelf: 'start',
            orientation: 'isMobile',
            textTransform: 'none',
          }}
        />
        <Tab
          label="Logs / Auditoria"
          icon={<HistoryIcon />}
          iconPosition="start"
          {...a11yProps(3)}
          sx={{
            alignSelf: 'start',
            orientation: 'isMobile',
            textTransform: 'none',
          }}
        />
      </Tabs>
      <Box width="100%">
        <TabPanel value={value} index={0}>
          <ProductTicketSettings {...props} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ProductTicketAreasLots
            {...props}
            productId={productId || ''}
            offers={offers}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ProductTicketSales productId={productId} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ProductTicketLogs productId={productId} />
        </TabPanel>
      </Box>
    </Stack>
  )
}

export default ProductTickets
